<template>
    <div class="v-picture-wrapper">
        <template v-if="$store.state.listContent.isShowContent">
            <div :class="['picture-content', openPictureModal && 'minify']">
                <div
                    :class="['picture-list', openPictureModal && 'zoom']"
                    v-if="hasData"
                >
                    <pictureItem
                        v-for="(item, i) in pictureItemData"
                        :key="item.id"
                        :index="item.id"
                        :data="item"
                        :active="openPictureModal && item.id === postId"
                        :dataAmount="pictureItemData.length"
                        ref="pictureItems"
                        @likes="likes"
                        @click.native="
                            current_item_model(
                                $event,
                                item.id,
                                i,
                                item.favorite_id,
                                item.thumbnail,
                                item.preview_url
                            )
                        "
                        @emitInformationShow="picture_information_show"
                    />
                </div>
                <!-- 没数据显示 -->
                <div class="no-result" v-else>
                    <img :src="noResult" alt="" />
                    <p>{{ $TL.noResult }}</p>
                </div>
            </div>
        </template>
        <template v-else>
            <v-spinner />
        </template>
        <div class="data-load-tips">
            <v-spinner v-if="isSpiner" />
            <div class="load-all-data" v-if="isLoadAll">
                {{ $TL.LoadAllOver }}
            </div>
        </div>
        <picture-view-modal
            v-if="openPictureModal"
            :data="currentItemInfo"
            :itemIndex="currentIndex"
            :itemData="itemData"
            @likes="update_likes"
            @downloads="add_downloads"
            @modelHide="picture_model_hide"
            @modelArrowChange="picture_forward_backward_status"
        />
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { timeout } from "@/utils/util.js";
import { locate_current_picture, scroll_schema } from "./hook";
import {
    getBasicData,
    getSearchResult,
    getLatestUpdateSchema,
    getFavoritePicturesSchema,
} from "./ajax.js";
import { getSchema } from "@/api/configs";
import pictureItem from "@/components/picture-item/index";
import pictureViewModal from "@/components/picture-viewer-modal/index";
export default {
    name: "v-picture-wrapper",
    props: {
        data: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            pictureItemData: [],
            dataTransfer: null,
            postId: null,
            currentItemInfo: {},
            currentIndex: -1,
            metaInfo: "",
            type: "",
            isSpiner: false,
            isLoadAll: false,
            hasData: true,
            itemData: {},
            noResult: "./mgmedia/img/no-result.png",
        };
    },
    watch: {
        getSchemaData(newData) {
            //  显示 loading
            this.$store.state.listContent.isShowContent = false;
            this.init_get_schema();
            this.reset_data_settings();
            //  判断是否显示 最新过滤按钮

            this.updateIsFilterBtn(
                this.$P.schemaType == "latestUpdate" ? true : false
            );
        },
        favoritesStatus(newData) {
            //  更新 下标为第 index 个数据的收藏状态
            this.pictureItemData.map((item) => {
                if (item.id === newData.pictureId[0]) {
                    item.isFavorited = newData.isFavor;
                    item.favorite_id = newData.favoriteId;
                }
            });

            //  todo 循环数组
            //  当展开图片详情页时点击列表的收藏，更新图片详情页的收藏信息
            this.currentItemInfo.isFavorited = newData.isFavor;
            this.update_picture_favorite(newData.pictureId, newData.status);
            this.hasData = this.pictureItemData.length ? true : false;
        },
    },
    components: { pictureItem, pictureViewModal },
    computed: {
        ...mapState("vModal", ["openPictureModal"]),
        ...mapState("triggerEvtents", ["getSchemaData"]),
        ...mapState("favorites", ["favoritesStatus"]),
    },
    created() {
        this.init_get_schema();
        window.scroll_Fn = this.scroll_get_schema;
    },
    mounted() {
        window.addEventListener("scroll", scroll_schema, false);
        //  关闭所有卡片的提示信息
        this.$P.$on("close_pictureitem_information", () => {
            this.$refs.pictureItems.map((el, i) =>
                el.close_information_modal()
            );
        });
    },

    beforeDestroy() {
        window.removeEventListener("scroll", scroll_schema, false);
    },

    methods: {
        ...mapMutations("download", ["updateDownAmount", "updateDownCount"]),
        ...mapMutations("vModal", ["updateOpenPictuerModal"]),
        ...mapMutations("userCentered", ["updateUserCenteredInfo"]),
        ...mapMutations("favorites", ["updatePictureAmount"]),
        ...mapMutations("mixins", ["updateIsFilterBtn"]),
        ...mapMutations("triggerEvtents", [
            "updateClearSearchCondition",
            "updateResetSideNav",
        ]),

        //  根据 最新更新接口和搜索接口 获取数据
        schema_data_distribute(para) {
            switch (this.$P.schemaType) {
                case "latestUpdate":
                    return getLatestUpdateSchema(para);
                    break;
                case "basicData":
                    return getBasicData(para);
                    break;
                case "search":
                    return getSearchResult(para);
                    break;
                case "favoritePictures":
                    return getFavoritePicturesSchema(para);
                    break;
                default:
                    break;
            }
        },

        //  默认加载数据
        async init_get_schema() {
            //  页面返回顶部
            window.scrollTo(0, 0);
            this.isLoadAll = false;
            let data = await this.schema_data_distribute();
            this.pictureItemData = data.data;
            this.metaInfo = data.meta;
            window.continueScroll = true;
            this.$P.$emit("updateFavoritesCount", this.metaInfo.total);
            await timeout(200);
            this.$store.state.listContent.isShowContent = true;
            this.hasData = this.pictureItemData.length ? true : false;
        },
        //  滚动加载数据
        async scroll_get_schema() {
            //  如果没有数据，就返回
            if (this.pictureItemData.length < 1) return;
            let currentPage = this.metaInfo.current_page;
            let lastPage = this.metaInfo.last_page;
            currentPage++;

            if (currentPage > lastPage || lastPage === 1) {
                this.isLoadAll = true;
                return;
            }
            this.isSpiner = true;
            let data = await this.schema_data_distribute({ page: currentPage });
            for (let index = data.data.length - 1; index > 0; index--) {
                this.pictureItemData.push(data.data[index]);
            }
            // this.pictureItemData = this.pictureItemData.concat(data.data);

            this.metaInfo = data.meta;
            window.continueScroll = true;
            this.isSpiner = false;
        },

        // 加载详情页数据
        async load_item_data(id, index, isLikes) {
            if (this.currentIndex === index) return;
            this.postId = id;
            this.currentIndex = index;

            let { data } = await getSchema(`medias/${id}`);
            //  添加判断当签图片是否已被点赞字段
            data.isLikes = isLikes;
            this.currentItemInfo = data;
        },
        //  当前图片弹框显示操作
        async current_item_model(
            ev,
            id,
            index,
            favorite_id,
            thumbnail,
            preview_url
        ) {
            locate_current_picture(ev.currentTarget);
            this.updateOpenPictuerModal(true);
            this.load_item_data(
                id,
                index,
                $(`[data-postid="${id}"]`).find(".like-btn").hasClass("favor")
            );

            this.itemData = {
                favorite_id,
                thumbnail,
                preview_url,
                dataAmount: this.pictureItemData.length,
            };
        },

        reset_data_settings() {
            this.picture_model_hide();
            this.deselect_all_fn();
            if (this.$P.schemaType !== "search") {
                //  重置搜索条件
                this.updateClearSearchCondition();
            }
            //  重置侧边栏状态
            if (this.$P.schemaType !== "basicData") {
                this.updateResetSideNav();
            }
        },

        //  隐藏当前图片弹框
        picture_model_hide() {
            this.updateOpenPictuerModal(false);
            this.currentIndex = -1;
            this.currentItemInfo = {};
        },

        //  重新加载数据时，取消全选
        deselect_all_fn() {
            //  取消全选
            this.updateDownAmount("");
            this.updateDownCount(false);
            this.$store.state.mixins.isAllSelect = false;
        },

        //  全选数据
        select_all_fn() {
            this.updateDownAmount(this.pictureItemData.length);
            this.pictureItemData.map((item) => {
                this.updateDownCount({
                    postId: item.id,
                    downUrl: item.download_url,
                });
            });
        },

        //  图片前后切换更新
        async picture_forward_backward_status(index) {
            let id = this.pictureItemData[index]["id"];
            this.load_item_data(id, index);
            locate_current_picture(`[data-postid="${this.postId}"]`);
            this.itemData["preview_url"] =
                this.pictureItemData[index]["preview_url"];
        },

        //  更新列表页的点赞数据
        update_likes(itemId, isLikes, likes) {
            let itemsInfo = (items) => {
                items.isLikes = isLikes;
                items.likes = likes;
            };
            this.pictureItemData.find((items) => {
                return items.id === itemId && itemsInfo(items);
            });
        },

        //  更新详情页的点赞数据
        likes(itemId, isLikes, likes) {
            //  当展开图片详情页时点击列表的点赞，更新图片详情页的点赞信息
            if (this.currentItemInfo.id !== itemId) return;
            this.currentItemInfo.isLikes = isLikes;
            this.currentItemInfo.likes = likes;
        },
        //  在详情页点下载后更新列表数量
        add_downloads(itemId) {
            let item = this.pictureItemData.find((items) => {
                return (
                    items.id === itemId &&
                    (items.downloads = items.downloads + 1)
                );
            });
        },

        update_picture_favorite(itemId, status) {
            //  只在个人中心执行
            if (this.$route.name.includes("favorites")) {
                if (status === "remove") {
                    this.update_favorites_data(itemId);

                    //  更新个人中心图片数量
                    this.updateUserCenteredInfo({
                        m_count: this.favoritesStatus.m_count,
                    });
                } else if (status === "change") {
                    if (this.$route.name === "favorites-details") {
                        this.update_favorites_data(itemId);
                    }
                }

                //  更新单个收藏夹内图片数量
                this.$P.$emit(
                    "updateFavoritesCount",
                    this.favoritesStatus.m_count
                );

                this.picture_model_hide();
            }
        },
        //  如果是收藏夹详情页，取消收藏时删除取消的图片
        update_favorites_data(itemId) {
            this.pictureItemData = this.pictureItemData.filter((item) => {
                return item.id !== itemId[0];
            });
        },
        picture_information_show(itemId) {
            this.$P.$emit("close_pictureviewer_information");
            this.$refs.pictureItems.map((el, i) => {
                itemId === el.index
                    ? el.open_information_modal()
                    : el.close_information_modal();
            });
        },
    },
};
</script>

<style lang="scss">
.v-picture-wrapper {
    display: flex;
    padding-bottom: 100px;
    position: relative;
    width: 100%;
    min-height: 60vh;

    &.modal-show {
        .picture-list {
            padding-right: 20px;
        }
    }

    .picture-content {
        width: 100%;

        &.minify {
            width: calc(100% - 44.8vw);
        }
    }

    .picture-list {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -8px;
        &:after {
            content: "";
            flex-grow: 99999;
        }

        &.zoom {
            padding-right: 20px;
        }
    }

    .v-spinner {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }

    .data-load-tips {
        position: absolute;
        bottom: 10px;
        left: 0;
        right: 0;
        margin: auto;

        .v-spinner {
            bottom: 100px;
        }

        .load-all-data {
            width: 400px;
            padding: 4px 16px;
            background-color: #f5f5f5;
            border: 1px solid #c6c6c6;
            border-radius: $border-radius;
            margin: auto;
            font-size: 14px;
            text-align: center;
        }
    }

    .no-result {
        width: 100%;
        height: 50vh;
        margin: auto;
        margin-top: 50px;
        @include flex(center, center, nowrap, column);

        img {
            max-height: 100%;
            max-width: 450px;
        }

        p {
            font-size: 24px;
            font-weight: 600;
            max-width: 480px;
            text-align: center;
        }
    }
}
</style>
